function Breakout({ children = <>&gt;1,000&#37;</>, title = '' }) {
    return <span title={title}>{children}</span>;
}

export default Breakout;
